module.exports = __webpack_public_path__ + "static/media/star.1fcf0602.svg";